import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import "./PersonalDetailsModal.css";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function PersonalDetailsModal({ show, handleClose }) {
  // ---------------- Date of Birth ----------------

  const dayOptions = Array.from({ length: 31 }, (_, i) => ({
    value: i + 1,
    label: String(i + 1).padStart(2, "0"),
  }));

  const monthOptions = [
    { value: "January", label: "January" },
    { value: "February", label: "February" },
    { value: "March", label: "March" },
    { value: "April", label: "April" },
    { value: "May", label: "May" },
    { value: "June", label: "June" },
    { value: "July", label: "July" },
    { value: "August", label: "August" },
    { value: "September", label: "September" },
    { value: "October", label: "October" },
    { value: "November", label: "November" },
    { value: "December", label: "December" },
  ];

  const yearOptions = Array.from({ length: 70 }, (_, i) => {
    const year = new Date().getFullYear() - i;
    return {
      value: year,
      label: year.toString(),
    };
  });

  const [day, setDay] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);

  // ---------------- Equal Opportunity ----------------

  const equalOptions = [
    { value: "General", label: "General" },
    { value: "SC", label: "SC" },
    { value: "ST", label: "ST" },
    { value: "OBC", label: "OBC" },
    { value: "PWD", label: "PWD" },
  ];

  const [equalOpportunity, setEqualOpportunity] = useState(null);

  // ---------------- Country ----------------

  const countryOptions = [
    { value: "India", label: "India" },
    { value: "USA", label: "USA" },
    { value: "Canada", label: "Canada" },
    { value: "Australia", label: "Australia" },
  ];

  const [residency, setResidency] = useState([
    { value: "India", label: "India" },
  ]);

  const [workPermit, setWorkPermit] = useState([]);

  // ---------------- Nationality ----------------

  const [nationality, setNationality] = useState("Indian");

  // ---------------- Specially Abled ----------------

  const [specialAbled, setSpecialAbled] = useState(false);

  const disabilityTypeOptions = [
    { value: "physical", label: "Physical Disability" },
    { value: "visual", label: "Visual Disability" },
    { value: "hearing", label: "Hearing Disability" },
    { value: "speech", label: "Speech Disability" },
    { value: "intellectual", label: "Intellectual Disability" },
  ];

  const disabilitySubTypeOptions = [
    { value: "locomotor", label: "Locomotor Disability" },
    { value: "blindness", label: "Blindness" },
    { value: "lowvision", label: "Low Vision" },
    { value: "deaf", label: "Deaf" },
    { value: "autism", label: "Autism Spectrum Disorder" },
  ];

  const [disabilityType, setDisabilityType] = useState(null);
  const [disabilitySubType, setDisabilitySubType] = useState(null);
  const [description, setDescription] = useState("");

  // ---------------- React Select Style ----------------

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "46px",
      border: "1px solid #d8dce7",
      borderRadius: "4px",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #d8dce7",
      },
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#98a1b2",
    }),

    multiValue: (base) => ({
      ...base,
      border: "1px solid #666",
      borderRadius: "18px",
      background: "#fff",
      padding: "2px 4px",
    }),

    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  // ---------------- Save ----------------

  const handleSave = () => {
    console.log({
      dob: {
        day: day?.value,
        month: month?.value,
        year: year?.value,
      },
      equalOpportunity,
      residency,
      workPermit,
      nationality,
      disabilityType,
      disabilitySubType,
      description,
    });

    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      scrollable
      size="lg"
      dialogClassName="common-modal personal-modal"
    >
      <Modal.Header className="we-modal-header d-flex align-items-center">
        <Modal.Title className="we-modal-title">
          {" "}
          <Button
            variant="link"
            className="we-back-btn p-0 me-2"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>{" "}
          Personal details
        </Modal.Title>
        <button
          type="button"
          className="btn-close ms-auto"
          onClick={handleClose}
          aria-label="Close"
        ></button>
      </Modal.Header>

      <Modal.Body className="personal-modal__body">
        {/* Date of Birth */}

        <Form.Group className="mb-4">
          <Form.Label className="personal-modal__label">
            Date of Birth
          </Form.Label>

          <Row className="g-2">
            <Col md={3}>
              <Select
                options={dayOptions}
                value={day}
                onChange={setDay}
                placeholder="Day"
                styles={selectStyles}
              />
            </Col>

            <Col md={4}>
              <Select
                options={monthOptions}
                value={month}
                onChange={setMonth}
                placeholder="Month"
                styles={selectStyles}
              />
            </Col>

            <Col md={3}>
              <Select
                options={yearOptions}
                value={year}
                onChange={setYear}
                placeholder="Year"
                styles={selectStyles}
              />
            </Col>
          </Row>
        </Form.Group>

        {/* Equal Opportunity */}

        <Form.Group className="mb-4">
          <Form.Label className="personal-modal__label">
            Equal Opportunity
          </Form.Label>

          <Select
            options={equalOptions}
            value={equalOpportunity}
            onChange={setEqualOpportunity}
            placeholder="Select your equal opportunity"
            styles={selectStyles}
          />
        </Form.Group>

        {/* Residency */}

        <Form.Group className="mb-4">
          <Form.Label className="personal-modal__label">
            Countries of Residency
          </Form.Label>

          <Select
            isMulti
            options={countryOptions}
            value={residency}
            onChange={setResidency}
            placeholder="Choose the countries where you hold residency"
            styles={selectStyles}
          />
        </Form.Group>

        {/* Work Permit */}

        <Form.Group className="mb-4">
          <Form.Label className="personal-modal__label">
            Work Permit Countries
          </Form.Label>

          <Select
            isMulti
            options={countryOptions}
            value={workPermit}
            onChange={setWorkPermit}
            placeholder="Select the countries you have a work permit for"
            styles={selectStyles}
          />
        </Form.Group>

        {/* Nationality */}

        <Form.Group className="mb-4">
          <Form.Label className="personal-modal__label">Nationality</Form.Label>

          <Form.Control
            value={nationality}
            onChange={(e) => setNationality(e.target.value)}
          />
        </Form.Group>

        {/* Specially Abled */}

        <Form.Check
          type="switch"
          id="special-abled"
          className="personal-modal__switch"
          label="I am specially abled"
          checked={specialAbled}
          onChange={(e) => setSpecialAbled(e.target.checked)}
        />

        {specialAbled && (
          <>
            <Form.Group className="mt-4 mb-4">
              <Form.Label className="personal-modal__label">
                Type <span className="text-danger">*</span>
              </Form.Label>

              <Select
                options={disabilityTypeOptions}
                value={disabilityType}
                onChange={setDisabilityType}
                placeholder="Select your disability type"
                styles={selectStyles}
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="personal-modal__label">
                Sub-Type <span className="text-danger">*</span>
              </Form.Label>

              <Select
                options={disabilitySubTypeOptions}
                value={disabilitySubType}
                onChange={setDisabilitySubType}
                placeholder="Select your disability sub type"
                styles={selectStyles}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label className="personal-modal__label">
                Description
              </Form.Label>

              <Form.Control
                as="textarea"
                rows={5}
                maxLength={1000}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter your description"
              />

              <div className="personal-modal__char-count">
                Max. {description.length}/1000 character
              </div>
            </Form.Group>
          </>
        )}
      </Modal.Body>

      <Modal.Footer className="personal-modal__footer">
        <Button className="personal-modal__save-btn" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PersonalDetailsModal;
